module.exports = __webpack_public_path__ + "img/p1.b1d2b9ef.svg";